import { render, staticRenderFns } from "./Lgpd.vue?vue&type=template&id=12f5a159&scoped=true&"
import script from "./Lgpd.vue?vue&type=script&lang=js&"
export * from "./Lgpd.vue?vue&type=script&lang=js&"
import style0 from "./css/lgpd.css?vue&type=style&index=0&id=12f5a159&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f5a159",
  null
  
)

export default component.exports